import Marquee from "react-fast-marquee";

const NAMES = [
  "BLACK EYED PEAS",
  "DAESUNG",
  "TAEYANG",
  "YE",
  "SF9",
  "JASON CHEN",
  "魏如昀",
  "ALAN WALKER",
  "SUPER JUNIOR",
  "MAMAMOO",
  "PARIS HILTON",
  "R3HAB",
];

export default function ArtistMarquee() {
  return (
    <div aria-hidden="true" className="py-10 md:py-16 border-y border-white/10 bg-[#050505] overflow-hidden" data-testid="artist-marquee">
      <Marquee speed={45} gradient={false}>
        {NAMES.map((n, i) => (
          <span key={n} className="flex items-center">
            <span
              className={`font-display uppercase text-5xl md:text-7xl px-6 leading-none ${
                i % 2 === 0 ? "text-[#ffde00]" : "text-outline"
              }`}
            >
              {n}
            </span>
            <span className="text-[#27272a] text-3xl">✕</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
